import _ from 'lodash';
import * as api from '../../../api';

import { ProcedureToAdd } from './ModalBody';

///////////////////////////////////////////////////
////// CONSTS

export const LateralityPrettyMap: Record<api.Procedure.Laterality, string> = {
  [api.Procedure.Laterality.Bilateral]: 'Both sides',
  [api.Procedure.Laterality.Left]: 'Left side',
  [api.Procedure.Laterality.Right]: 'Right side',
};

export const SearchPlaceholder = 'Add another surgery';

export const StandardProcedureList: api.Procedure.StandardProcedure[] = [
  {
    id: '1',
    displayName: 'Appendectomy',
    name: 'APPENDECTOMY',
    requireLaterality: false,
  },
  {
    id: '2',
    displayName: 'CABG (Heart bypass surgery)',
    name: 'HEART_BYPASS_SURGERY',
    requireLaterality: false,
  },
  {
    id: '3',
    displayName: 'Cardiac pacemaker placement',
    name: 'CARDIAC_PACEMAKER_PLACEMENT',
    requireLaterality: false,
  },
  {
    id: '4',
    displayName: 'Cesarean section (C-Section)',
    name: 'CESAREAN_SECTION',
    requireLaterality: false,
  },
  {
    id: '5',
    displayName: 'Cholecystectomy (Gallbladder removal)',
    name: 'CHOLECYSTECTOMY',
    requireLaterality: false,
  },
  {
    id: '6',
    displayName: 'Craniotomy',
    name: 'CRANIOTOMY',
    requireLaterality: false,
  },
  {
    id: '7',
    displayName: 'Gastric bypass surgery',
    name: 'GASTRIC_BYPASS_SURGERY',
    requireLaterality: false,
  },
  {
    id: '8',
    displayName: 'Heart valve replacement',
    name: 'HEART_VALVE_REPLACEMENT',
    requireLaterality: false,
  },
  {
    id: '9',
    displayName: 'Hernia repair',
    name: 'HERNIA_REPAIR',
    requireLaterality: true,
  },
  {
    id: '10',
    displayName: 'Hip replacement',
    name: 'HIP_REPLACEMENT',
    requireLaterality: true,
  },
  {
    id: '11',
    displayName: 'Hysterectomy',
    name: 'HYSTERECTOMY',
    requireLaterality: false,
  },
  {
    id: '12',
    displayName: 'ICD (Internal cardiac defibrillator placement)',
    name: 'INTERNAL_CARDIAC_DEFIBRILLATOR_PLACEMENT',
    requireLaterality: false,
  },
  {
    id: '13',
    displayName: 'Joint repair',
    name: 'JOINT_REPAIR',
    requireLaterality: true,
  },
  {
    id: '14',
    displayName: 'Kidney transplant',
    name: 'KIDNEY_TRANSPLANT',
    requireLaterality: true,
  },
  {
    id: '15',
    displayName: 'Knee replacement',
    name: 'KNEE_REPLACEMENT',
    requireLaterality: true,
  },
  {
    id: '16',
    displayName: 'Lumpectomy (Breast mass removal)',
    name: 'LUMPECTOMY',
    requireLaterality: true,
  },
  {
    id: '17',
    displayName: 'Mastectomy (Breast removal)',
    name: 'MASTECTOMY',
    requireLaterality: true,
  },
  {
    id: '18',
    displayName: 'Nissen fundoplication',
    name: 'NISSEN_FUNDOPLICATION',
    requireLaterality: false,
  },
  {
    id: '19',
    displayName: 'Prostatectomy',
    name: 'PROSTATECTOMY',
    requireLaterality: false,
  },
  {
    id: '20',
    displayName: 'Rotator cuff repair',
    name: 'ROTATOR_CUFF_REPAIR',
    requireLaterality: true,
  },
  {
    id: '21',
    displayName: 'Shoulder replacement',
    name: 'SHOULDER_REPLACEMENT',
    requireLaterality: true,
  },
  {
    id: '22',
    displayName: 'Thyroidectomy',
    name: 'THYROIDECTOMY',
    requireLaterality: false,
  },
  {
    id: '23',
    displayName: 'Tonsillectomy',
    name: 'TONSILLECTOMY',
    requireLaterality: true,
  },
  {
    id: '24',
    displayName: 'Tubal ligation',
    name: 'TUBAL_LIGATION',
    requireLaterality: false,
  },
  {
    id: '25',
    displayName: 'TURP (Transurethral resection of prostate)',
    name: 'TRANSURETHRAL_RESECTION_OF_PROSTATE',
    requireLaterality: false,
  },
  {
    id: '26',
    displayName: 'Other (specify)',
    name: 'OTHER',
    requireLaterality: false,
  },
];

export const MonthList = [
  { name: 'JANUARY', index: 1 },
  { name: 'FEBRUARY', index: 2 },
  { name: 'MARCH', index: 3 },
  { name: 'APRIL', index: 4 },
  { name: 'MAY', index: 5 },
  { name: 'JUNE', index: 6 },
  { name: 'JULY', index: 7 },
  { name: 'AUGUST', index: 8 },
  { name: 'SEPTEMBER', index: 9 },
  { name: 'OCTOBER', index: 10 },
  { name: 'NOVEMBER', index: 11 },
  { name: 'DECEMBER', index: 12 },
];

///////////////////////////////////////////////////
////// HELPERS

export const sortProcedures = (
  procedures: api.Procedure.PrevisitProcedure[],
) => {
  return _.sortBy(procedures, 'canRemove');
};

export const splitAndUpperFirst = (str: string): string => {
  if (!str) return '';

  return _.upperFirst(str.replace(/_/g, ' ').toLowerCase());
};

export const isValidProcedureToAdd = (procedureToAdd: ProcedureToAdd) => {
  return !(
    !procedureToAdd.procedure ||
    !procedureToAdd.dateYear ||
    (procedureToAdd.procedure.name === 'OTHER' && !procedureToAdd.nameRaw)
  );
};
